import { IconProps } from '../icon';

export function AgendaIcon(props: IconProps) {
  return (
    <svg
      id="Agenda"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="39.162"
      viewBox="0 0 40 39.162"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_317"
            data-name="Rectangle 317"
            width="40"
            height="39.162"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_314"
            data-name="Rectangle 314"
            width="40"
            height="31.887"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-4">
          <rect
            id="Rectangle_315"
            data-name="Rectangle 315"
            width="34.022"
            height="7.275"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_583" data-name="Groupe 583" clipPath="url(#clipPath)">
        <g id="Groupe_582" data-name="Groupe 582">
          <g id="Groupe_581" data-name="Groupe 581" clipPath="url(#clipPath)">
            <g
              id="Groupe_577"
              data-name="Groupe 577"
              transform="translate(0 7.275)"
              opacity="0.5"
            >
              <g id="Groupe_576" data-name="Groupe 576">
                <g
                  id="Groupe_575"
                  data-name="Groupe 575"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_235"
                    data-name="Tracé 235"
                    d="M40,106.353v6.7l-.157,2.162-1.515,20.959a1.031,1.031,0,0,1-1.031,1.031H2.225a1.031,1.031,0,0,1-1.031-1.031L0,114.888a1.011,1.011,0,0,1,.006-.105v0A1.011,1.011,0,0,1,0,114.674v-8.321a1.034,1.034,0,0,1,1.033-1.033H38.965A1.034,1.034,0,0,1,40,106.353"
                    transform="translate(0 -105.32)"
                    fill="#8eac12"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_580"
              data-name="Groupe 580"
              transform="translate(2.883)"
              opacity="0.3"
            >
              <g id="Groupe_579" data-name="Groupe 579">
                <g
                  id="Groupe_578"
                  data-name="Groupe 578"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_236"
                    data-name="Tracé 236"
                    d="M75.757,7.275H41.735V1.039A1.039,1.039,0,0,1,42.774,0H74.718a1.039,1.039,0,0,1,1.039,1.039Z"
                    transform="translate(-41.735)"
                    fill="#8eac12"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_237"
              data-name="Tracé 237"
              d="M177.184,248.343l2.009-.3a2.429,2.429,0,0,0,.515,1.426,1.3,1.3,0,0,0,2.105-.092,2.635,2.635,0,0,0,.443-1.622,2.418,2.418,0,0,0-.425-1.513,1.266,1.266,0,0,0-1.031-.55,3,3,0,0,0-.949.189l.225-2.063a1.714,1.714,0,0,0,1.277-.431,1.686,1.686,0,0,0,.462-1.267,1.58,1.58,0,0,0-.335-1.069,1.085,1.085,0,0,0-.859-.386,1.165,1.165,0,0,0-.909.446,2.272,2.272,0,0,0-.456,1.32l-1.919-.4a4.55,4.55,0,0,1,1.164-2.631,3.051,3.051,0,0,1,2.183-.82,2.891,2.891,0,0,1,2.35,1.052,3.57,3.57,0,0,1,.871,2.33,3.1,3.1,0,0,1-.392,1.556,3.608,3.608,0,0,1-1.176,1.214,2.572,2.572,0,0,1,1.482,1.072,3.564,3.564,0,0,1,.572,2.072,4.281,4.281,0,0,1-1.078,3,3.356,3.356,0,0,1-2.566,1.185,3.265,3.265,0,0,1-2.413-1,4.3,4.3,0,0,1-1.15-2.723"
              transform="translate(-164.945 -222.106)"
              fill="#8eac12"
            />
            <path
              id="Tracé_238"
              data-name="Tracé 238"
              d="M312.888,251.838h-2.072V242.3a7.129,7.129,0,0,1-2.685,1.919v-2.3a5.752,5.752,0,0,0,1.793-1.253,4.855,4.855,0,0,0,1.288-2.08h1.676Z"
              transform="translate(-286.847 -222.106)"
              fill="#8eac12"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AgendaIcon;
